<template>
  <iframe :src="docsUrl" class="api-docs-frame" title="API Docs" />
</template>

<script>
export default {
  name: 'ApiDocs',
  computed: {
    apiHost() {
      const rootApiUrl = process.env.VUE_APP_ROOT_API_URL;
      if (rootApiUrl) {
        return rootApiUrl.replace('/api/v2', '');
      }
      return `${location.protocol}//${location.host}`;
    },
    docsUrl() {
      return `${this.apiHost}/docs?domain=${encodeURIComponent(
        location.hostname,
      )}`;
    },
  },
};
</script>

<style scoped>
.api-docs-frame {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
